<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 16:07:18
 * @LastEditTime: 2020-07-17 17:12:16
 * @Description: 创建试卷
 -->
<template>
  <div class="content">
    <head-title />
    <create-step :current="currentStep" />
    <div class="step-item">
      <component :is="stepComponent"
        :exam-id="examId"
        @upload-success="uploadSuccessHandler" @upload-failed="uploadFailedHandler" />
    </div>
    <create-action-bar
      v-if="pageType === 'create'"
      :current="currentStep"
      :exam-id="examId"
      :step-one-next-btn-enable="stepOneNextBtnEnable"
      @prev="prevStepHandler"
      @next="nextStepHandler" @done-paper-setting="donePaperSettingHandler" />
    <edit-action-bar v-else-if="pageType === 'edit'" :paper-id="paperIdForRoute" />
    <add-question-by-product-group-modal />
    <add-question-by-product-code-modal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import HeadTitle from './components/HeadTitle.vue';
import CreateStep from './components/CreateStep.vue';
import UploadFile from './components/UploadFile.vue';
import LibraryComQuestion from './components/LibraryComQuestion.vue';
import GenerateTestPaper from './components/GenerateTestPaper.vue';
import CreateActionBar from './components/CreateActionBar.vue';
import EditActionBar from './components/EditActionBar.vue';
import AddQuestionByProductGroupModal from './components/AddQuestionByProductGroupModal.vue';
import AddQuestionByProductCodeModal from './components/AddQuestionByProductCodeModal.vue';

const breadcrumb = [
  { text: '统考中心', href: '/tr/portal/index.jsp' },
  { text: '创建试卷' },
];

export default {
  name: 'CreateTestPaper',
  components: {
    HeadTitle,
    CreateStep,
    CreateActionBar,
    EditActionBar,
    AddQuestionByProductGroupModal,
    AddQuestionByProductCodeModal,
  },
  props: {
    examId: { type: [Number, String], required: false },
    paperIdForRoute: { type: [Number, String], required: false },
  },
  data() {
    return {
      currentStep: 0,
      stepComponent: UploadFile,
      stepOneNextBtnEnable: false,
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      pageType: 'createPaperStore/pageType',
      paperId: 'createPaperStore/paperId',
      paperName: 'createPaperStore/paperName',
      examTime: 'createPaperStore/examTime',
      examPassScore: 'createPaperStore/examPassScore',
    }),
    pageTypeAtRoute() {
      return this.$route.meta.type;
    },
  },
  watch: {
    currentStep(value) {
      switch (value) {
        case 0:
          this.stepComponent = UploadFile;
          break;
        case 1:
          this.stepComponent = LibraryComQuestion;
          break;
        case 2:
          this.stepComponent = GenerateTestPaper;
          break;
        default:
          break;
      }
    },
    pageTypeAtRoute: {
      immediate: true,
      handler(type) {
        this.setPageType({ type });
      },
    },
    pageType: {
      immediate: true,
      handler(type) {
        if (type === 'edit') {
          this.currentStep = 2;

          this.editConcurrentRquestThisPageData();
        } else if (type === 'create') {
          this.currentStep = 0;

          this.createConcurrentRquestThisPageData();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setPageType: 'createPaperStore/invokeSetPageType',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setPaperName: 'createPaperStore/invokeSetPaperName',
      setQuestionComplete: 'createPaperStore/invokeSetQuestionComplete',
      setExamTime: 'createPaperStore/invokeSetExamTime',
      setExamPassScore: 'createPaperStore/invokeSetExamPassScore',
      setExamObjectList: 'createPaperStore/invokeSetExamObjectList',
      setExamObjectTotal: 'createPaperStore/invokeSetExamObjectTotal',
    }),
    /**
     * 上一步处理函数
     */
    prevStepHandler() {
      this.currentStep -= 1;

      if (this.currentStep === 0) {
        this.stepOneNextBtnEnable = false;
      }

      document.querySelector('.page').scrollTo(0, 0);
    },
    /**
     * 下一步处理函数
     */
    nextStepHandler() {
      this.currentStep += 1;

      document.querySelector('.page').scrollTo(0, 0);

      if (this.currentStep === 2) {
        this.requestQuestionCompleteAndSetting();
      }
    },
    /**
     * 完成创建试卷处理函数
     */
    donePaperSettingHandler() {
      this.requestDonePaperSettingAndSetting();
    },
    /**
     * 必考题上传成功
     */
    uploadSuccessHandler() {
      this.stepOneNextBtnEnable = true;
    },
    /**
     * 必考题上传失败
     */
    uploadFailedHandler() {
      this.stepOneNextBtnEnable = false;
    },
    /**
     * 创建试卷第三步请求题目统计信息并设置
     */
    requestQuestionCompleteAndSetting() {
      this.requestQuestionComplete()
        .then((result) => {
          this.setQuestionComplete({ questionComplete: result.result });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 创建试卷第三步请求题目统计信息
     */
    requestQuestionComplete() {
      const params = {
        paperId: this.paperId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateQuestionComplete(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求完成创建试卷设置并设置
     */
    requestDonePaperSettingAndSetting() {
      this.setProcessingShowState({ show: true });

      this.requestDonePaperSetting()
        .then(() => {
          alert('创建试卷成功');
          this.setProcessingShowState({ show: false });
          window.location.href = document.referrer;
        })
        .catch((result) => {
          alert(result.msg);
          this.setProcessingShowState({ show: false });
        });
    },
    /**
     * 请求完成创建试卷设置
     */
    requestDonePaperSetting() {
      const params = {
        paperId: this.paperId,
        examId: this.examId,
        paperName: this.paperName,
        examTime: this.examTime,
        passScore: this.examPassScore,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateDonePaperSetting(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * pageType为create时并发请求此页面首屏展示所有数据
     */
    createConcurrentRquestThisPageData() {
      const indexParams = {
        examId: this.examId,
      };

      axios.all([
        this.$http.examcenter.paperCreateIndex(indexParams),
      ])
        .then(axios.spread((paperIndex) => {
          if (paperIndex.code === '200') {
            this.setPaperName({ paperName: `试卷${paperIndex.data.paperIndex}` });
          } else {
            alert(paperIndex.data.msg);
          }

          this.setProcessingShowState({ show: false });
        }))
        .catch(() => {
          alert('数据获取失败');
          this.setProcessingShowState({ show: false });
        });
    },
    /**
     * pageType为edit时并发请求此页面首屏展示所有数据
     */
    editConcurrentRquestThisPageData() {
      const questionCompleteParams = {
        paperId: this.paperIdForRoute,
      };

      axios.all([
        this.$http.examcenter.paperCreateQuestionComplete(questionCompleteParams),
        axios.get(`/examcentersite/paper/${this.paperIdForRoute}/scope`, { headers: { psstoken: this.token } }),
      ])
        .then(axios.spread((questionComplete, examObjectList) => {
          if (questionComplete.code === '200') {
            this.setQuestionComplete({ questionComplete: questionComplete.data.result });
            this.setExamTime({ examTime: questionComplete.data.paper.examTime });
            this.setExamPassScore({ examPassScore: questionComplete.data.paper.passScore });
          } else {
            alert(questionComplete.msg);
          }

          if (examObjectList.data.code === '200') {
            if (examObjectList.data.data.type === 'Excel') {
              const list = [
                {
                  staffType: '--',
                  branch: '--',
                  subBranch: '--',
                  channel: '--',
                  compoChannel: '--',
                  userType: '--',
                  userTypeDetail: '--',
                  starLevel: '--',
                  hrMainGroup: '--',
                  groupName: '--',
                  count: examObjectList.data.data.total,
                },
              ];

              this.setExamObjectList({ examObjectList: list });
            } else if (examObjectList.data.data.type === 'Scope') {
              const { list } = examObjectList.data.data;

              list.forEach((item) => {
                if (item.dispatched) {
                  item.staffType = '第三方员工';

                  if (!item.branch) {
                    item.branch = '所有分公司';
                  }

                  if (!item.subBranch) {
                    item.subBranch = '所有办事处';
                  }

                  if (!item.channel) {
                    item.channel = '所有渠道';
                  }

                  if (!item.compoChannel) {
                    item.compoChannel = '所有小渠道';
                  }

                  if (!item.userType) {
                    item.userType = '所有';
                  }

                  if (!item.userTypeDetail) {
                    item.userTypeDetail = '所有';
                  }

                  if (!item.starLevel) {
                    item.starLevel = '所有';
                  }

                  if (!item.mainGroup) {
                    item.hrMainGroup = '所有主营产品';
                  }

                  if (!item.groupName) {
                    item.groupName = '--';
                  }
                } else {
                  item.staffType = '非第三方员工';

                  if (!item.branch) {
                    item.branch = '所有分公司';
                  }

                  if (!item.subBranch) {
                    item.subBranch = '所有办事处';
                  }

                  if (!item.channel) {
                    item.channel = '所有渠道';
                  }

                  if (!item.compoChannel) {
                    item.compoChannel = '所有小渠道';
                  }

                  if (!item.userType) {
                    item.userType = '--';
                  }

                  if (!item.userTypeDetail) {
                    item.userTypeDetail = '--';
                  }

                  if (!item.starLevel) {
                    item.starLevel = '--';
                  }

                  if (!item.mainGroup) {
                    item.hrMainGroup = '--';
                  }

                  if (!item.groupName) {
                    item.groupName = '所有用户组';
                  }
                }
              });

              this.setExamObjectList({ examObjectList: list });
            }

            this.setExamObjectTotal({ examObjectTotal: examObjectList.data.data.total });
          } else {
            alert(examObjectList.data.msg);
          }

          this.setProcessingShowState({ show: false });
        }));
    },
  },
  created() {
    this.setBreadcrumb({
      breadcrumb,
    });

    this.setProcessingShowState({ show: true });
  },
  beforeRouteLeave(to, from, next) {
    if (window.confirm('试卷创建还未完成，当前退出不保留任何操作，是否确定退出？')) {
      next();
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px 20px;
  margin-bottom: 0;

  > .step-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 26px 0;
  }
}
</style>
